/* eslint-disable */
__webpack_public_path__ = `/${Playtech.Variables.themeName}/js/app-out/`;

// below hacks are needed for hub2shared, because all chunks must also have casinoname & site parameters
// once backbone is removed, this should be moved to app-react/js/webpack.js
function addParams(filename) {
    const params = new URLSearchParams();
    const search = new URLSearchParams(window.location.search);
    const casinoname = search.get('casinoname');
    const site = search.get('site');

    if (casinoname) {
        params.set('casinoname', casinoname);
    }

    if (site) {
        params.set('site', site);
    }

    if (params.size) {
        return `${filename}?${params.toString()}`;
    }

    return filename;
}

const script = __webpack_get_script_filename__;

__webpack_get_script_filename__ = (chunkId, ...args) => {
    return addParams(script(chunkId, ...args));
};

const miniCss = __webpack_require__.miniCssF;

__webpack_require__.miniCssF =  (chunkId, ...args) => {
    return addParams(miniCss(chunkId, ...args));
}
